import React, { useState } from 'react';
import { InboxOutlined } from "@ant-design/icons";
import { API_URL,BulkUploadType } from "../../../utils/Constant";
import { message, Upload, Button } from 'antd';
import XlUploadedTable from './xlUploadedTable';
import { downloadFile } from '../../../utils/utils';
import { useDispatch, useSelector } from "react-redux";
import { addBulkAgreementAction, editBulkAgreementAction, deleteBulkAgreementAction } from "../../../app/slice/bulkUploadSlice";

const { Dragger } = Upload;

export default function UploadComponent() {
  const [fileList, setFileList] = useState([]); // Store uploaded file
  const dispatch = useDispatch();
  const bulkUploadData = useSelector((state) => state.bulkUploadData.data);
  const token = useSelector((state) => state.auth.accessToken);


  const props = {
    name: "file",
    // showUploadList:false,
    multiple: false,
    showUploadList: false,
    fileList,
    action: `${API_URL}/contract/bulk-upload/`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    accept: BulkUploadType,
    beforeUpload(file) {
      const acceptedExt = BulkUploadType.split(",");
      const ext = file.name.split(".").pop();
      if (!acceptedExt.includes('.'+ ext)) {
        message.error("You can only upload xls and xlsx files!");
        return Upload.LIST_IGNORE; // Ignore invalid files
      }
      return true;
    },
    onChange(info) {
      const { fileList } = info;
      const { status, response } = info.file;
      console.log({ status, response }, 'status,response')
      if (status !== "uploading") {
        // return false;
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        // setXldata(response);
        dispatch(addBulkAgreementAction(response));
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
        return false
      }
      setFileList(fileList);
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
    onError(error) {
      setFileList([]);
      message.error("An error occurred during upload. Please try again.");
    },
  };

  const onInput = () => {
    const url = '/../../../assets/files/import_agreements.xlsx';
    downloadFile(url, 'importAgreements', true)
  }

  return (
    <div>
      <Button style={{ position: 'absolute', right: '20px', zIndex: '999' }} className='my-2' type="primary" onClick={(e) => {
        e.stopPropagation();
        onInput();
      }}>
        Import Data
      </Button>

      <Dragger
        disabled={bulkUploadData.length}
        { ...props }
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload. You can choose
          single or multiple file to upload.
        </p>
      </Dragger>

      <XlUploadedTable />
    </div>
  )
}
